/**
 * @generated SignedSource<<fd0ea0833b7ca298c76608f11bb00cb1>>
 * @relayHash 18fa54e2ca28ad2622498bf24b076364
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraProjectOptions = {
  projectType?: JiraProjectType | null | undefined;
};
export type projectJqlBuilderBasicInitQuery$variables = {
  cloudId: string;
  projectOptions?: JiraProjectOptions | null | undefined;
};
export type projectJqlBuilderBasicInitQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly project: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type projectJqlBuilderBasicInitQuery = {
  response: projectJqlBuilderBasicInitQuery$data;
  variables: projectJqlBuilderBasicInitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectOptions"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "projectOptions",
    "variableName": "projectOptions"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "projectJqlBuilderBasicInitQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlProjectFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedProjects",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlProjectFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlProjectFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraProject",
                              "kind": "LinkedField",
                              "name": "project",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "projectJqlBuilderBasicInitQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlProjectFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlProjectFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlProjectFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad",
    "metadata": {},
    "name": "projectJqlBuilderBasicInitQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fe20d750eadef8bafda1d590956fca21";

export default node;
